import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import projectKeys from '@/api/queries/project/keyFactory';
import proposalKeys from '@/api/queries/proposal/keyFactor';
import { graphql } from '@/gql';
import {
  MarkProposalAsDeclinedInput,
  MarkProposalAsDeclinedMutation,
} from '@/gql/graphql';

const MARK_PROPOSAL_AS_DECLINED_MUTATION = graphql(`
  mutation MarkProposalAsDeclined($input: MarkProposalAsDeclinedInput!) {
    markProposalAsDeclined(input: $input) {
      id
    }
  }
`);

const useMarkProposalAsDeclined = (args?: {
  proposalId?: string;
  projectId?: string;
  options?: UseMutationOptions<
    MarkProposalAsDeclinedMutation,
    unknown,
    MarkProposalAsDeclinedInput
  >;
}) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = args?.options ?? {};

  return useMutation({
    mutationFn: (input: MarkProposalAsDeclinedInput) => {
      return gqlClient.request(MARK_PROPOSAL_AS_DECLINED_MUTATION, { input });
    },
    onSuccess: (data, variables, context) => {
      if (args?.proposalId) {
        void queryClient.invalidateQueries({
          queryKey: proposalKeys.proposal(args.proposalId),
        });
      }
      if (args?.projectId) {
        void queryClient.invalidateQueries({
          queryKey: projectKeys.project(args.projectId),
        });
      }
      onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};

export default useMarkProposalAsDeclined;
